var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tab_pane active show",attrs:{"id":"product_list"}},[_c('div',{staticClass:"product__section--inner product__section--style3__inner"},[_c('div',{staticClass:"row row-cols-1 mb--n30"},_vm._l((_vm.products),function(product){return _c('ListProductItem',{key:product.id,attrs:{"product":product}})}),1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }